<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'MenuFormations'
});
</script>
<template>
  <ka-container
    code="menu-formations"
    :data="page.$info.menuFormations">
    <!-- Container 1 -->
    <ka-container code="container-1">
      <ka-icon
        code="icon"
        value="i-fa-solid:rocket" />
      <ka-text
        code="nos-formations"
        :options="{
          href: { name: `Formations` },
          click: page.nosFormationsClick
        }">
        <span v-html="t('menuFormations.container1.nosFormations.value', `Nos formations`)" />
      </ka-text>
    </ka-container>
    <!-- Container 2 -->
    <ka-container code="container-2">
      <ka-icon
        code="icon-1"
        value="i-fa-solid:chart-line" />
      <ka-text
        code="pedagogie-matchers"
        :options="{
          href: { name: `Pedagogie` },
          click: page.pedagogieMatchersClick
        }">
        <span v-html="t('menuFormations.container2.pedagogieMatchers.value', `Pédagogie Matchers `)" />
      </ka-text>
    </ka-container>
    <!-- Container 3 -->
    <ka-container code="container-3">
      <ka-icon
        code="icon-2"
        value="i-fa-solid:coins" />
      <ka-text
        code="tarifs-financements"
        :options="{
          href: { name: `Financement` },
          click: page.tarifsFinancementsClick
        }">
        <span v-html="t('menuFormations.container3.tarifsFinancements.value', `Tarifs & financements`)" />
      </ka-text>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncPageStore } from 'kapix-components-vue3'
import { menuFormationsMenu } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p60')
const page = menuFormationsMenu()

syncPageStore(page)
</script>
